import { useId } from 'react'

export interface Club {
    name: string
    short: string
    initials: string
    color: string
}

/**
 * Wappen-Platzhalter: stilisierter Schild mit Initialen in der Vereinsfarbe.
 * Echte Wappen gibt es bewusst nicht - alle Vereine sind erfunden.
 */
export function ClubCrest({ club, size = 48 }: { club: Club; size?: number }) {
    // useId statt club.short: zwei Wappen desselben Vereins auf einer Seite
    // wuerden sich sonst denselben Gradienten teilen und der zweite bliebe leer.
    const gradientId = useId()

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 48 48"
            role="img"
            aria-label={club.name}
            className="[filter:drop-shadow(0_2px_4px_rgba(0,0,0,.4))]"
        >
            <defs>
                <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0" stopColor={club.color} stopOpacity="1" />
                    <stop offset="1" stopColor={club.color} stopOpacity=".65" />
                </linearGradient>
            </defs>
            <path
                d="M24 2 L42 7 L42 26 Q42 38 24 46 Q6 38 6 26 L6 7 Z"
                fill={`url(#${gradientId})`}
                stroke="rgba(255,255,255,.15)"
                strokeWidth="1.5"
            />
            <rect x="6" y="18" width="36" height="4" fill="rgba(255,255,255,.18)" />
            <text
                x="24"
                y="32"
                textAnchor="middle"
                fontFamily="Sora, system-ui, sans-serif"
                fontSize="11"
                fontWeight="800"
                fill="#fff"
                letterSpacing="0.5"
            >
                {club.initials}
            </text>
        </svg>
    )
}
